import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../../../store/root-reducer';

import GoalSelectionStep from './goal-selection-step';
import { CampaignGoal } from '../../../type';

interface GoalSelectionStepContainerProps {
  handleModalClose: () => void;
  goals?: CampaignGoal[];
  saveCurrentStepDetails?: (payload: any) => void;
}

const GoalSelectionStepContainer: React.FC<GoalSelectionStepContainerProps> = ({
  handleModalClose,
  saveCurrentStepDetails,
}) => {
  const { data } = useSelector(
    (state: RootState) => state?.sequence?.generateAiSeqModal,
  );

  return (
    <GoalSelectionStep
      handleModalClose={handleModalClose}
      goals={data.goals}
      saveCurrentStepDetails={saveCurrentStepDetails}
    />
  );
};

export default memo(GoalSelectionStepContainer);
